import { api } from "@/shared/libs/axiosClient";
import {
  CancelCollectionRequest,
  CancelCollectionResponse,
  CollectionStatusParams,
  CollectionStatusResponse,
} from "@/types/collection-types";

/**
 * 수집 현황 조회
 */
export async function fetchCollectionStatus(
  params: CollectionStatusParams
): Promise<CollectionStatusResponse> {
  return api.get<CollectionStatusResponse>("/collection-status", { params });
}

/**
 * 진행 중인 수집 취소
 */
export async function cancelCollections(
  request: CancelCollectionRequest
): Promise<CancelCollectionResponse> {
  return api.post<CancelCollectionResponse>("/collection-status/cancel", request);
}
